import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { FlexContainer, Paragraph, CheckMark } from 'heliocor-ui'

const ApplicationComplete = () => {

    const { t } = useTranslation()
    const [seconds, setSeconds] = useState(4)
    const [isActive, setIsActive] = useState(false)

    const urlOk = useSelector(state => state.settings.urlOk)
  
    const startTimer = () => setIsActive(true)
  
    const resetTimer = () =>  {
		setSeconds(4)
		setIsActive(false)
    }
  
    useEffect(() => {
      	let interval = null
      	if (isActive) {
        	interval = setInterval(() => {
          		setSeconds(seconds => seconds - 1)
        	}, 1000)
		} else if (!isActive) {
			clearInterval(interval)
		}
		return () => clearInterval(interval)
    }, [isActive, seconds])

    useEffect(() => {
        if(urlOk){
            startTimer()
            const timer = setTimeout(() => {
                document.location.href = urlOk 
            }, 4000)
        return () => {
            clearTimeout(timer)
            return resetTimer()
        }
    }}, [urlOk])


    return (
        <FlexContainer column alignItems='center' justifyContent='center' width='100%' height='90%' textAlign='center' data-cy="applicationComplete">
            <CheckMark fill='aqua100' size='50' />
            <Paragraph value={t('warning.thanksApplicationComplete')} />
            {urlOk && <Paragraph value={t('redirectMessage', {seconds, url: urlOk})} />}
        </FlexContainer>
    )
}

export { ApplicationComplete }